const UTILS = require("../libs/utils.js");
const config = require("../config.js");
var vA767 = [{
  obj: {
    src: "ghost_0",
    side: 2,
    glowText: true,
    emissive: "#ffffff"
  },
  behaviour: 0,
  bobD: 1,
  bobS: 0.005,
  emissive: true,
  scale: 4
}, {
  src: "model",
  asset: "30171e",
  noFog: true,
  mYOff: 8,
  side: 2,
  lvl: 30,
  canShoot: true,
  pathInput: "99",
  targPlr: true,
  visDis: 700,
  proj: 1,
  pjD: 20,
  pjSp: 0.9,
  pjSC: 1.6,
  pjMS: 4,
  pjA: "30401e",
  health: 1100,
  score: 10,
  speed: 0.9,
  frate: 3600,
  turnSpd: 20,
  emissive: true,
  scale: 4,
  shotEff: 4
}, {
  src: "model",
  asset: "50838e",
  canHit: true,
  mYOff: 6,
  hbh: 0.6,
  rotY: true,
  visDis: 700,
  targPlr: true,
  melrng: 20,
  meldmg: 20,
  health: 700,
  score: 10,
  speed: 0.6,
  turnSpd: 4,
  emissive: true,
  scale: 4,
  eventN: "onAIDeath",
  actions: [{
    trigConst: 1,
    trigConstTx: "pump",
    trigAct: 62
  }]
}, {
  src: "model",
  asset: "50578q",
  noFog: true,
  furthTarg: true,
  mYOff: 8,
  lvl: 50,
  speed: 2.9,
  turnSpd: 5.5,
  grv: 0.4,
  canHit: true,
  melrng: 20,
  melDel: 900,
  hrate: 900,
  meldmg: 20,
  targPlr: true,
  visDis: 400,
  aiChasd: 50,
  mSize: 1.4,
  mROff: 270,
  health: 5000,
  score: 100,
  melShake: 0.05,
  emissive: true,
  scale: 4,
  agr: 3206,
  mel: 3236,
  melh: 29672,
  animS: 1.8,
  mYOff: -0.001,
  startAnim: "",
  hbh: 2.9,
  hbw: 1.4,
  shotEff: 4,
  reward: ["6435"],
  eventN: "onAIDeath",
  actions: [{
    trigConst: 1,
    trigConstTx: "mirror",
    trigAct: 65
  }]
}, {
  src: "ghost_0",
  frames: 2,
  frameT: 400,
  side: 2,
  obj: {
    src: "ghost_0",
    side: 2,
    glowText: true,
    emissive: "#ffffff",
    frames: 2,
    frameT: 400
  },
  canShoot: true,
  visDis: 500,
  proj: 1,
  pjD: 10,
  pjSp: 0.9,
  pjSC: 1.6,
  pjMS: 1.4,
  health: 300,
  targPlr: true,
  score: 10,
  speed: 0.8,
  frate: 2500,
  turnSpd: 20,
  emissive: true,
  scale: 4
}];
const vLN20002 = 2000;
const vLN20003 = 2000;
function f2119(game, p16893, p16894) {
  var v13516;
  var vA768 = [];
  this.init = function (p16895, p16896, p16897, p16898, p16899, p16900, p16901) {
    this.isAI = true;
    this.sid = p16901;
    var v13517 = p16900 || vA767[p16899];
    this.dat = v13517;
    this.index = p16899;
    this.active = true;
    this.name = p16898 || "";
    v13517.asset = (v13517.asset || "") + "";
    var v13518 = v13517.asset.includes("g");
    var v13519 = v13517.asset.includes("q");
    var v13520 = v13517.asset.includes("f");
    var v13521 = v13517.asset.includes("e");
    var v13522 = v13517.asset.includes("n");
    var v13523 = v13517.asset.includes("s");
    var v13524 = v13517.asset.includes("a");
    var v13525 = v13517.asset.includes("m");
    var v13526 = v13517.asset.includes("r");
    var v13527 = v13517.asset.includes("p");
    var v13528 = v13517.asset.includes("b");
    this.assetID = v13517.asset.replace(/[^\d]/g, "");
    this.hasAnim = v13518 || v13519 || v13520;
    this.animS = v13517.animS;
    this.soundR = v13517.soundR || 1;
    this.startAnim = v13517.startAnim || "Idle";
    this.bobD = v13517.bobD || 0;
    this.bobS = v13517.bobS || 0;
    this.bobVal = 0;
    this.interpolate = false;
    this.frames = v13517.frames;
    this.frameT = v13517.frameT;
    this.rAnim = v13517.rAnim;
    this.rAnimA = v13517.rAnimA;
    this.reward = v13517.reward;
    this.rewardMethod = v13517.rewardMethod || 0;
    this.rewardReq = v13517.rewardReq || 0;
    this.rewardNode = v13517.rewardNode || 0;
    this.maxHealth = v13517.health || 0;
    this.health = this.maxHealth;
    this.speed = (v13517.speed || 0) * 0.031;
    this.turnSpd = (v13517.turnSpd || 0) * 0.002;
    this.gravity = (v13517.grv || 0) * 0.1;
    this.killScore = v13517.score || 0;
    this.respawnT = v13517.respawnT || 0;
    this.respawnR = !!v13517.respawnR;
    this.critDmg = v13517.critDmg || 0;
    this.critHei = v13517.critHei || 0;
    this.lastHit = {};
    this.breakAttack = 0;
    this.breakMove = 0;
    this.breakTimer = 0;
    this.behaviour = 1;
    this.behavType = v13517.behav || 0;
    this.didMov = 0;
    this.actionFreq = 0;
    this.ignoreOnStuck = !!v13517.ignoreOnStuck;
    this.driftOnStuck = !!v13517.driftOnStuck;
    this.invincibleOnStuck = !!v13517.invincibleOnStuck;
    this.canShoot = !!v13517.canShoot;
    this.fireRate = v13517.frate || 2000;
    if (this.fireRate < 0) {
      this.fireRate = 200;
    }
    this.shootTimer = this.fireRate || 0;
    this.shotSprd = v13517.aicur || 0;
    this.shotOff = this.behavType == 4 ? 10 : 2;
    this.shotOffH = !!v13517.shoOffH;
    this.shootBreak = v13517.shoBrk || 0;
    this.shotArchY = UTILS.toRad(v13517.shoArY || 0);
    this.shotDelay = v13517.shoDel || 0;
    this.shotShake = v13517.shoShake || 0;
    this.waitShoot = 0;
    this.effectOnShot = v13517.shotEff == null ? undefined : parseInt(v13517.shotEff);
    this.effectOnHit = v13517.hitEff == null ? undefined : parseInt(v13517.hitEff);
    var v13529 = v13517.pjA ? (v13517.pjA || "").replace(/[^\d]/g, "") : null;
    this.projOb = {
      s: v13517.pjA ? v13529 + "/model" : "orb_0",
      d: v13517.pjD,
      pjA: v13529 ? v13517.pjA : null,
      pjSp: v13517.pjSp,
      pjG: v13517.pjG == null ? v13517.pjG : v13517.pjG * 0.0002,
      pjGL: v13517.pjGL != null,
      pjT: v13517.pjT != null,
      pjSC: v13517.pjSC,
      pjMS: v13517.pjMS,
      pjS: v13517.pjS,
      ex: v13517.explode ? 40 : undefined,
      expS: v13517.explode ? 60 : undefined,
      effectInd: this.effectOnShot,
      noObjC: this.behavType == 5,
      emis: v13517.pjA && v13521 || !v13517.pjA ? "#ffffff" : null
    };
    this.specAtkTim = 0;
    this.specAtkTim2 = 0;
    this.usedSpecial = false;
    this.spawnMTim = 0;
    this.spawnCap = 20;
    this.mSize = (v13517.mSize || 4) * (this.assetID ? p16894 ? 0.5 : 2 : 1);
    this.scale = this.mSize * (v13517.hbw || 1).round(1);
    this.height = this.mSize * (v13517.hbh || 1).round(1);
    this.mYOff = v13517.mYOff || 0;
    this.mROff = v13517.mROff || 0;
    this.avoidAiC = true;
    this.canHit = !!v13517.canHit;
    this.meleeRange = v13517.melrng || 0;
    this.meleeRadius = v13517.melrad || 0;
    if (this.meleeRange < 10) {
      this.meleeRange = 10;
    }
    this.meleeChaseRange = this.meleeRange * 0.7;
    this.hitDelay = v13517.melDel || 400;
    this.hitDelayC = null;
    this.hitDMG = v13517.meldmg || 10;
    this.hitTimer = 0;
    this.hitRate = v13517.hrate || 800;
    if (this.hitRate < 0) {
      this.hitRate = 200;
    }
    this.toHit = null;
    this.hitBreak = 400;
    this.meleeShake = v13517.melShake || 0;
    this.x = (p16895 || 0).round(1);
    this.y = (p16896 || 0).round(1);
    this.z = (p16897 || 0).round(1);
    this.startP = {
      x: this.x,
      y: this.y,
      z: this.z
    };
    this.posHist = [];
    this.physMov = !!v13517.pMov;
    this.onGround = true;
    this.yVel = 0;
    this.xVel = 0;
    this.zVel = 0;
    this.stuckTime = 0;
    this.forceDirection = null;
    this.forceDirectionTimer = 0;
    this.wasStuck = false;
    this.invincible = false;
    this.permInvincible = false;
    this.stuckCount = 0;
    this.xD = 0;
    this.yD = 0;
    this.rotY = v13517.rotY;
    this.target = null;
    this.ignoreList = {};
    this.ignoreTimer = 0;
    this.oldTargetId = null;
    this.targtFurth = !!v13517.furthTarg;
    this.targetAI = !!v13517.targAI;
    this.targPlr = !!v13517.targPlr;
    this.vision = v13517.visDis || 120;
    this.aiChasd = v13517.aiChasd || 10;
    this.xray = !!v13517.xrayVis;
    this.friendly = !!v13517.friendly;
    var v13530 = v13517.pathInput + "";
    this.followPath = !!v13530 && !!v13530.length;
    this.pathList = v13530.split(",") || [];
    this.pathIndex = 0;
    this.pathIndDir = 1;
    this.pathType = config.pathTypes[v13517.pathType || 0];
    if (!this.pathType) {
      this.pathType = config.pathTypes[0];
    }
    this.roamRad = v13517.roamRad || 0;
    this.roamTarget = null;
    this.roamTime = v13517.roamTime || 1000;
    this.roamTimer = 0;
    this.team = v13517.team;
    this._team = v13517.team;
    this.forceTeamTimer = 0;
    this.canBSeen = false;
    this.sentTo = [];
    this.alwaysName = this.height >= 6;
    this.tagScale = v13517.tagScale || 1;
    this.lvl = v13517.lvl || 0;
    this.noVis = v13517.noVis;
    this.noFog = v13517.noFog;
    this.side = v13517.side || 0;
    this.fTrans = !!v13517.fTrans;
    this.opacity = UTILS.isNumber(v13517.opacity) ? v13517.opacity : 1;
    this.alphaTest = UTILS.isNumber(v13517.alphaTest) ? v13517.alphaTest : 0;
    this.noSmooth = v13517.noSmooth;
    if (p16894 && !v13517.noVis) {
      if (this.mesh) {
        p16894.scene.remove(this.mesh);
      }
      this.mesh = p16894.genObj3D(p16895, p16896, p16897);
      var v13531 = this.assetID && v13517 ? this.assetID + "/" + v13517.src : "ghost_0";
      this.meshRef = p16894[this.hasAnim ? "loadAnimMesh" : "loadMesh"](p16900 ? {
        fileExt: v13519 ? "glb" : v13518 ? "gltf" : v13520 ? "fbx" : null,
        side: this.side,
        asset: !!this.assetID,
        startAnim: this.startAnim,
        emissive: v13521 ? "#ffffff" : null,
        src: v13531,
        animS: this.animS,
        opacity: this.opacity,
        transparent: this.fTrans || this.opacity != 1,
        noFog: this.noFog,
        alphaTest: this.alphaTest || (v13524 ? 0.02 : 0),
        normal: v13522,
        spec: v13523,
        tFilter: this.noSmooth ? 1003 : 1006,
        metalness: v13525 ? 1 : 0,
        roughness: v13526 ? 1 : 0,
        displacement: v13527 ? 1 : 0,
        bump: v13528 ? 1 : 0,
        frames: this.frames,
        frameT: this.frameT,
        rAnim: this.rAnim,
        rAnimA: this.rAnimA
      } : v13517.obj, 0, (this.assetID ? 0 : this.scale) + (this.mYOff || 0), 0, UTILS.toRad(this.mROff || 0), this.scale, this.mesh);
      p16894.scene.add(this.mesh);
    }
    this.shootSound = v13517.atk || 0;
    this.shootHitSound = v13517.atkh || 0;
    this.melSound = v13517.mel || 0;
    this.melHitSound = v13517.melh || 0;
    this.deathSound = v13517.dth || 0;
    this.aggroSound = v13517.agr || 0;
    if (typeof window != "undefined" && "SOUND" in window) {
      this.idleSound = v13517.idl || 0;
      this.idlSoundI = 5000;
      this.idlSoundT = this.idlSoundI * UTILS.randFloat(0.8, 1.2);
    }
    this.trigActions = v13517.actions;
    this.trigChance = v13517.chance;
    this.trigConstE = v13517.constE || 0;
    if (v13517.eventN) {
      this[v13517.eventN] = true;
    }
    this.interface = v13517.interface;
    this.interfaceT = v13517.interfaceT;
    this.singleUse = v13517.singleUse;
    this.effects = {};
    this.attributes = {};
    this.attributeTimers = [];
    for (var vLN02475 = 0; vLN02475 < game.effectConfig.length; vLN02475++) {
      this.attributes[game.effectConfig[vLN02475].key] = game.effectConfig[vLN02475].def;
      this.attributeTimers[vLN02475] = [];
    }
    this.ticker = 0;
    this.tickerC = 0;
    this.zappedBy = null;
    this.dmgList = [];
  };
  this.getData = function () {
    return [this.sid, this.index, this.name, this.x.round(1), this.y.round(1), this.z.round(1), this.dat ? {
      hasAnim: this.hasAnim ? 1 : 0,
      animS: this.animS,
      soundR: this.soundR,
      team: this.team,
      health: this.maxHealth,
      mSize: this.mSize,
      mYOff: this.mYOff,
      mROff: this.mROff,
      hbh: (this.dat.hbh || 1).round(1),
      asset: this.dat.asset || 0,
      idl: this.dat.idl,
      src: this.dat.src,
      noVis: this.noVis ? 1 : 0,
      tagScale: this.tagScale || 1,
      lvl: this.lvl || 0,
      side: this.side,
      opacity: this.opacity,
      texEncode: this.texEncode,
      alphaTest: this.alphaTest,
      noSmooth: this.noSmooth,
      noFog: this.noFog,
      fTrans: this.fTrans,
      frames: this.frames,
      frameT: this.frameT,
      rAnim: this.rAnim,
      rAnimA: this.rAnimA,
      bobD: this.bobD,
      bobS: this.bobS
    } : 0];
  };
  this.emitSound = function (p16902, p16903, p16904, p16905, p16906) {
    if (UTILS.isNumber(p16902) && p16902 != "0") {
      game.playSound(p16902, (p16903 || 1) * 0.9, 0, Math.round(p16904 || this.x), Math.round(p16905 || this.y), Math.round(p16906 || this.z), true, (this.soundR || 1) * 1, false, null, null, true, true);
    }
  };
  this.tickAI = function (p16907) {
    this.ticker -= p16907;
    if (this.ticker <= 0 && (this.ticker = 500, this.tickerC++, this.attributes.zap && this.tickerC % 2 == 0)) {
      var v13532 = this.zappedBy ? game.players.findBySid(this.zappedBy) : null;
      var v13533 = this.attributes.zap;
      if (this.changeHealth(-v13533, v13532)) {
        this.kill(v13532 || null);
      }
      game.showHit(v13532, this, Math.round(v13533), false, true);
    }
    for (var vLN02476 = 0; vLN02476 < this.attributeTimers.length; vLN02476++) {
      if (this.attributeTimers[vLN02476].length) {
        for (var v13534 = this.attributeTimers[vLN02476].length - 1; v13534 >= 0; --v13534) {
          this.attributeTimers[vLN02476][v13534] -= p16907;
          if (this.attributeTimers[vLN02476][v13534] <= 0) {
            this.attributeTimers[vLN02476].splice(v13534, 1);
            this.removeEffect(vLN02476, 1);
          }
        }
      }
    }
  };
  this.update = function (p16908) {
    if (p16894) {
      if (!this.active || !this.mesh || !this.mesh.visible) {
        return;
      }
      if (this.bobD && this.bobS) {
        this.bobVal += p16908 * this.bobS;
      }
      if (this.interpolate) {
        this.dt += p16908;
        var v13535 = Math.min(1.6, this.dt / (1000 / game.aiSyncT));
        v13535 /= game.config ? game.config.deltaMlt : 1;
        this.mesh.position.x = this.x1 + (this.x - this.x1) * v13535;
        this.mesh.position.y = this.y1 + (this.y - this.y1) * v13535;
        this.mesh.position.z = this.z1 + (this.z - this.z1) * v13535;
        this.mesh.rotation.y = this.xD;
      } else {
        this.mesh.position.x = this.x;
        this.mesh.position.y = this.y;
        this.mesh.position.z = this.z;
        this.mesh.rotation.y = this.xD;
      }
      p16893.playAnim(this, this.didMov ? "Move" : "Idle");
      if (this.idleSound) {
        this.idlSoundT -= p16908;
        if (this.idlSoundT <= 0) {
          this.idlSoundT = this.idlSoundI * UTILS.randFloat(0.8, 1.2);
          game.playerSound(this.idleSound, null, this.x, this.y, this.z, 1, (this.soundR || 1) * 1, 300, null, null, true, true);
        }
      }
    } else {
      if (this.behavior == 0) {
        return;
      }
      if (this.rspTimer) {
        this.rspTimer -= p16908;
        if (this.rspTimer <= 0) {
          this.active = true;
          this.target = null;
          this.ignoreList = {};
          this.stuckTime = 0;
          this.oldTargetId = null;
          this.x = this.startP.x;
          this.y = this.startP.y;
          this.z = this.startP.z;
          this.health = this.maxHealth;
          this.rspTimer = 0;
          this.dmgList.length = 0;
        } else {
          return;
        }
      }
      if (!this.active) {
        return;
      }
      this.tickAI(p16908);
      if (this.breakMove > 0) {
        this.breakMove -= p16908;
        if (this.breakMove <= 0) {
          this.breakMove = 0;
        }
      }
      this.oldX = this.x;
      this.oldY = this.y;
      this.oldZ = this.z;
      this.oldTargetId = this.target && this.target.isPlayer ? this.target.id : null;
      this.wasStuck;
      this.wasStuck = false;
      if (this.forceTeamTimer) {
        this.forceTeamTimer -= p16908;
        if (this.forceTeamTimer <= 0) {
          this.forceTeamTimer = 0;
          this.team = this._team;
          this.target = null;
          this.actionFreq = 0;
        }
      }
      for (var v13536 in this.ignoreList) {
        this.ignoreList[v13536] -= p16908;
        if (this.ignoreList[v13536] <= 0) {
          this.ignoreList[v13536] = 0;
          delete this.ignoreList[v13536];
        }
      }
      if (game.AI.forceTargetTimer) {
        this.actionFreq = game.AI.forceTargetTimer;
        this.target = game.AI.forceTarget;
        this.forceDirectionTimer = 0;
        this.forceDirection = null;
      }
      var vLN1171 = 1;
      if (this.behavType == 1 && this.target) {
        this.breakTimer += p16908;
        if (this.breakTimer >= 5000) {
          this.breakTimer = -UTILS.randInt(0, 5000);
          this.breakAttack = 4000;
        }
        if (this.health <= this.maxHealth / 1.5 && (vLN1171 = 1.5, this.specAtkTim -= p16908, this.specAtkTim <= 0)) {
          this.specAtkTim = UTILS.randInt(7000, 12000);
          this.breakMove = 2000;
          this.breakAttack = 3000;
          for (var vLN85 = 8, vLN02481 = 0, v13569 = game.projectiles.stored[1], v13581 = 0; v13581 < vLN85; ++v13581) {
            game.projectiles.init(this.x, this.y + this.shotOff, this.z, vLN02481, 0, v13569, this, {}, true, this.projOb);
            vLN02481 += Math.PI * 2 / vLN85;
          }
        }
        if (this.health <= this.maxHealth / 2 && (vLN1171 = 2, this.specAtkTim2 -= p16908, this.specAtkTim2 <= 0)) {
          this.emitSound(3236);
          this.specAtkTim2 = UTILS.randInt(12000, 16000);
          this.specAtkTim = 0;
          var v13538 = UTILS.randFloat(-Math.PI, Math.PI);
          var vLN10014 = 100;
          this.x = this.startP.x + vLN10014 * Math.cos(v13538);
          this.z = this.startP.z + vLN10014 * Math.sin(v13538);
        }
      }
      if (this.behavType == 2 && this.target) {
        if (this.health <= this.maxHealth / 2 && (this.shootTimer > 7000 && (this.shootTimer = 7000), !this.usedSpecial)) {
          this.usedSpecial = true;
          for (var vLN614 = 6, vLN02479 = 0, v13581 = 0; v13581 < vLN614; ++v13581) {
            var v13545 = this.scale * 2 + 70;
            var v13546 = this.x + v13545 * Math.cos(vLN02479);
            var v13547 = this.y + this.scale * 2 + 10;
            var v13548 = this.z + v13545 * Math.sin(vLN02479);
            this.emitSound(3236, null, this.x, this.y, this.z);
            game.AI.spawn(null, 2, "Jack O' Lantern", v13546, v13547, v13548);
            vLN02479 += Math.PI * 2 / vLN614;
          }
        }
        this.specAtkTim -= p16908;
        if (this.specAtkTim <= 0) {
          this.specAtkTim = UTILS.randInt(5000, 10000);
          this.breakAttack = 1000;
          for (var vLN85 = 8, vLN02481 = 0, v13569 = game.projectiles.stored[1], v13581 = 0; v13581 < vLN85; ++v13581) {
            game.projectiles.init(this.x, this.y + 3 + this.height + this.shotOff, this.z, vLN02481, 0, v13569, this, {}, true, this.projOb);
            vLN02481 += Math.PI * 2 / vLN85;
          }
        }
        if (this.spawnCap > 0 && (this.spawnMTim += p16908, this.spawnMTim >= 6000)) {
          this.spawnCap--;
          this.spawnMTim = -UTILS.randInt(0, 5000);
          var v13553 = UTILS.randFloat(-Math.PI, Math.PI);
          var v13545 = this.scale * 2 + 100;
          var v13546 = this.x + v13545 * Math.cos(v13553);
          var v13547 = this.y + this.scale * 2 + 10;
          var v13548 = this.z + v13545 * Math.sin(v13553);
          this.emitSound(3236, null, v13546, v13547, v13548);
          game.AI.spawn(null, 4, "Lost Soul", v13546, v13547, v13548);
        }
      }
      if (this.behavType == 3 && this.target && this.health <= this.maxHealth / 2) {
        if (this.shootTimer > 4000) {
          this.shootTimer = 4000;
        }
        vLN1171 = 2;
      }
      if (this.behavType == 4 && this.target && this.health <= this.maxHealth / 2 && !this.usedSpecial) {
        this.usedSpecial = true;
        game.AI.spawn(null, 3, "Mirror Image", this.startP.x, this.startP.y + 0.01, this.startP.z);
      }
      if (this.behavType == 5) {
        this.specAtkTim -= p16908;
        if (this.specAtkTim <= 0) {
          this.specAtkTim = UTILS.randInt(10000, 20000);
          this.emitSound(3236, null, this.x, this.y, this.z);
          game.AI.spawn(null, 1, "Drowned Sailor", this.x, this.y + 10, this.z);
        }
      }
      var v13549 = false;
      if (this.behaviour == 1) {
        this.actionFreq -= p16908;
        if (this.actionFreq <= 0) {
          var v13550;
          v13550 = this.targtFurth ? game.findFurthestFrom(this, this.x, this.y + this.height / 2, this.z, this.team, this.vision, this.xray, this.targetAI, this.targPlr) : game.findNearestTo(this, this.x, this.y + this.height / 2, this.z, this.team, this.vision, this.xray, this.targetAI, this.targPlr, false, this.ignoreList);
          if (this.target != v13550) {
            this.emitSound(this.aggroSound);
          }
          this.target = v13550;
          this.actionFreq = this.target ? this.targtFurth ? 7000 : 2000 : 5000;
        }
        var v13551 = Math.PI * 2;
        var v13552 = this.target || this.roamTarget || this.startP;
        if (!this.target) {
          if (this.followPath && this.pathList[this.pathIndex] != null && game.map.manager.pathNodes[this.pathList[this.pathIndex]]) {
            v13552 = game.map.manager.pathNodes[this.pathList[this.pathIndex]];
          } else if (this.roamRad && (this.roamTimer -= p16908, this.roamTimer <= 0)) {
            this.roamTimer = this.roamTime;
            var v13553 = UTILS.randFloat(-Math.PI, Math.PI);
            this.roamTarget = {
              x: this.startP.x + this.roamRad * Math.cos(v13553),
              y: this.startP.y,
              z: this.startP.z + this.roamRad * Math.sin(v13553)
            };
          }
        }
        var vA769 = UTILS.getDrs(v13552, this);
        if (game.AI.forceDance) {
          vA769 = [UTILS.toRad(UTILS.randInt(0, 360)), UTILS.toRad(UTILS.randInt(0, 360))];
        }
        var v13567 = (vA769[0] || 0) + Math.PI / 2;
        var vLN02485 = vA769[1] || 0;
        var v13557 = this.hitDelayC ? 0 : 1;
        if (this.waitShoot) {
          v13557 = 0.01;
        }
        if (game.AI.forceDance) {
          v13557 = 10;
        }
        var v13558 = (this.xD - v13567 + v13551) % v13551;
        var v13559 = Math.min(Math.abs(v13558 - v13551), v13558, this.turnSpd * v13557 * vLN1171 * p16908);
        var v13560 = v13558 - Math.PI >= 0 ? 1 : -1;
        this.xD += v13560 * v13559 + v13551;
        this.xD %= Math.PI * 2;
        v13558 = (this.yD - vLN02485 + v13551) % v13551;
        v13559 = Math.min(Math.abs(v13558 - v13551), v13558, this.turnSpd * v13557 * vLN1171 * p16908);
        v13560 = v13558 - Math.PI >= 0 ? 1 : -1;
        this.yD += v13560 * v13559 + v13551;
        this.yD %= Math.PI * 2;
        var vLN1022 = 10;
        if (this.target) {
          vLN1022 = this.aiChasd;
          if (this.canHit) {
            vLN1022 = this.meleeChaseRange;
          }
        } else if (v13552 && v13552.node) {
          vLN1022 = 1;
        }
        var v13561 = UTILS.getD3D(this.x, this.y, this.z, v13552.x, v13552.y, v13552.z);
        var v13562 = this.target && !v13552.node && v13561 < this.meleeChaseRange * 0.9;
        if ((v13561 >= vLN1022 || v13562) && this.speed && !this.hitDelayC && !this.waitShoot && !this.breakMove) {
          var v13580 = Math.min(v13561, this.speed * vLN1171 * p16908 * (v13562 ? -0.1 : 1));
          v13549 = true;
          if (this.physMov) {
            v13580 *= 0.01;
            var v13564 = config.groundDecel;
            if (!this.onGround) {
              v13564 = config.airDecel;
            }
            this.yVel -= p16908 * config.gravity;
            if (this.onGround) {
              this.xVel += v13580 * Math.sin(this.xD + Math.PI / 2) * Math.cos(this.yD);
              this.yVel += v13580 * Math.sin(this.yD);
              this.zVel += v13580 * Math.cos(this.xD + Math.PI / 2) * Math.cos(this.yD);
            }
            this.x += this.xVel * p16908;
            this.xVel *= Math.pow(v13564, p16908);
            this.xVel = UTILS.cropVal(this.xVel, config.decelMin);
            this.y += this.yVel * p16908;
            if (this.yVel > 0) {
              this.yVel -= p16908 * 0.000032;
            } else if (this.yVel <= -0.3) {
              this.yVel = -0.3;
            }
            this.z += this.zVel * p16908;
            this.zVel *= Math.pow(v13564, p16908);
            this.zVel = UTILS.cropVal(this.zVel, config.decelMin);
          } else {
            this.x += v13580 * Math.sin(this.xD + Math.PI / 2) * Math.cos(this.yD);
            this.z += v13580 * Math.cos(this.xD + Math.PI / 2) * Math.cos(this.yD);
            this.y += v13580 * Math.sin(this.yD);
            this.y -= this.gravity * p16908;
          }
        } else if (v13552 && v13552.node && this.pathList.length > 1) {
          if (this.pathType == "Loop") {
            this.pathIndex++;
            if (this.pathIndex >= this.pathList.length) {
              this.pathIndex = 0;
            }
          } else if (this.pathType == "Do Once") {
            this.pathIndex++;
            if (this.pathIndex >= this.pathList.length) {
              this.pathIndex = this.pathList.length - 1;
            }
          } else if (this.pathType == "Ping Pong") {
            this.pathIndex += this.pathIndDir;
            if (this.pathIndex >= this.pathList.length) {
              this.pathIndex = this.pathList.length - 1;
              this.pathIndDir *= -1;
            } else if (this.pathIndex <= 0) {
              this.pathIndex = 0;
              this.pathIndDir *= -1;
            }
          } else if (this.pathType == "Random") {
            this.pathIndex = UTILS.randInt(0, this.pathList.length - 1);
          }
        }
      }
      if (this.breakAttack > 0) {
        this.breakAttack -= p16908;
        if (this.breakAttack <= 0) {
          this.breakAttack = 0;
        }
      }
      if (!this.breakAttack && !this.waitShoot && this.canHit && (this.hitDelayC == null && (this.hitTimer -= p16908, this.hitTimer <= 0 && this.target && (this.hitTimer = 200, UTILS.getD3D(this.x, this.y, this.z, this.target.x, this.target.y, this.target.z) - (this.target.scale || 0) <= this.meleeChaseRange && (this.hitTimer = this.hitRate * UTILS.randInt(1, 1.2), this.behavType == 4 && UTILS.randInt(0, this.health <= this.maxHealth / 2 ? 1 : 3) == 0 && (this.hitTimer = 400), this.hitDelayC = this.hitDelay, this.toHit = this.target, this.toHit && (this.breakMove = this.hitBreak, this.emitSound(this.melSound), p16893.playAnim(this, "Melee"))))), this.hitDelayC != null && (this.hitDelayC -= p16908, this.hitDelayC <= 0 && (this.hitDelayC = null, this.meleeShake && game.rumble(this.x, this.y, this.z, this.meleeShake, 200), this.emitSound(this.melHitSound), this.toHit)))) {
        for (var v13581 = 0; v13581 < game.players.list.length; ++v13581) {
          v13568 = game.players.list[v13581];
          if ((!this.team || this.team != v13568.team) && v13568.active && UTILS.getD3D(this.x, this.y, this.z, v13568.x, v13568.y, v13568.z) <= this.meleeRange) {
            var v13565 = UTILS.getAngleDst(UTILS.getDrs(v13568, this)[0] || 0, this.xD) - Math.PI / 2;
            if (this.meleeRadius && Math.abs(v13565) > this.meleeRadius) {
              continue;
            }
            if (game.players.changeHealth(v13568, this, this.hitDMG)) {
              game.players.kill(v13568);
              if (this.onAIKillPlayer) {
                game.onTrigger(v13568, this);
              }
            } else if (this.effectOnHit != null) {
              game.players.giveEffect(v13568, this.effectOnHit);
            }
          }
        }
        for (var v13581 = 0; v13581 < game.AI.ais.length; ++v13581) {
          v13568 = game.AI.ais[v13581];
          if (this != v13568) {
            if (!this.team || this.team != v13568.team) {
              if (UTILS.getD3D(this.x, this.y, this.z, v13568.x, v13568.y, v13568.z) - (v13568.scale || 0) * 2 <= this.meleeRange + this.scale) {
                v13568.changeHealth(-this.hitDMG, this);
              }
            }
          }
        }
        this.toHit = null;
      }
      var v13566 = false;
      if (!this.breakAttack && !this.hitDelayC && !!this.canShoot && !this.waitShoot) {
        this.shootTimer -= p16908;
        if (this.target && this.shootTimer < 0) {
          if (this.shotDelay) {
            this.waitShoot = this.shotDelay;
          } else {
            v13566 = 1;
          }
          this.emitSound(this.shootSound);
          p16893.playAnim(this, "Shoot");
          this.breakMove = this.shootBreak;
        }
      }
      if (this.waitShoot) {
        this.waitShoot -= p16908;
        if (this.waitShoot <= 0) {
          this.waitShoot = 0;
          v13566 = 2;
        }
      }
      if (v13566) {
        this.shootTimer = this.fireRate;
        var v13567 = this.xD - Math.PI / 2;
        var vLN02485 = 0;
        this.emitSound(this.shootHitSound);
        if (this.shotShake) {
          game.rumble(this.x, this.y, this.z, this.shotShake, 200);
        }
        if (this.target) {
          var vA769 = [];
          if (this.shotOffH) {
            vA769 = UTILS.getDrs(this.target, this, this.shotOff + this.height / 2);
          } else if (this.target.isPlayer) {
            var v13568 = game.players.fetchState(this.target, this);
            vA769 = v13568 ? UTILS.getDrs(v13568, this, config.crouchDst * v13568.cV || 0 || 0) : UTILS.getDrs(this.target, this, config.crouchDst * this.target.crouchVal || 0 || 0);
          } else {
            vA769 = UTILS.getDrs(this.target, this, config.crouchDst * this.target.crouchVal || 0 || 0);
          }
          if (v13566 == 1) {
            v13567 = vA769[0] + UTILS.randFloat(-this.shotSprd, this.shotSprd);
          }
          vLN02485 = vA769[1] + UTILS.randFloat(-this.shotSprd, this.shotSprd) + this.shotArchY;
        }
        var v13569 = game.projectiles.stored[1];
        if (v13569) {
          game.projectiles.init(this.x, this.y + this.height / 2 + this.shotOff, this.z, v13567, vLN02485, v13569, this, {}, true, this.projOb);
        }
      }
      if (this.avoidAiC) {
        for (var v13581 = 0; v13581 < game.AI.ais.length; ++v13581) {
          v13568 = game.AI.ais[v13581];
          if (this != v13568) {
            var v13570 = UTILS.getDistance(this.x, this.z, v13568.x, v13568.z);
            if (v13570 < this.scale + v13568.scale) {
              v13570 = this.scale + v13568.scale - v13570;
              var v13571 = UTILS.getDir(this.x, this.z, v13568.x, v13568.z);
              this.x += v13570 * Math.cos(v13571);
              this.z += v13570 * Math.sin(v13571);
            }
          }
        }
      }
      var v13572 = null;
      this.onGround = false;
      v13516 = game.map.manager.getGridArrays(this.x, this.y, this.z);
      if (v13516) {
        vA768.length = 0;
        for (var v13581 = 0; v13581 < v13516.length; ++v13581) {
          v13568 = v13516[v13581];
          if (!(vA768.indexOf(v13568.sid) >= 0) && (vA768.push(v13568.sid), !v13568.onEnterObject && !v13568.onExitObject && !v13568.flag && !v13568.trigger && !v13568.noAICol && v13568.active && this.collidesAcc(v13568))) {
            if (v13568.ramp) {
              if (this.y < v13568.y + v13568.height) {
                var v13573 = Math.max(0, Math.min(1, UTILS.progressOnLine(v13568.ramp.sX, v13568.ramp.sZ, v13568.ramp.eX, v13568.ramp.eZ, this.x + this.scale * Math.cos(v13568.dir), this.z + this.scale * Math.sin(v13568.dir))));
                var v13574 = v13568.y - v13568.height + (v13568.height * 2 + 0.01) * v13573;
                if (v13572 === null) {
                  v13572 = v13574;
                }
                if (this.y <= v13574 && v13572 <= v13574) {
                  v13572 = v13574;
                  this.y = v13574;
                  this.yVel = 0;
                  this.onGround = true;
                }
              }
            } else if (v13568.redirection) {
              var v13575 = this.speed * vLN1171 * p16908 * 0.05;
              this.xVel = v13575 * Math.sin(-v13568.dir + Math.PI / 2) * Math.cos(v13568.boostDr);
              this.zVel = v13575 * Math.cos(-v13568.dir + Math.PI / 2) * Math.cos(v13568.boostDr);
            } else if (this.y < v13568.y + v13568.height && v13568.y + v13568.height - this.y <= 3 && this.oldY < v13568.y + v13568.height) {
              this.y = v13568.y + v13568.height;
              this.yVel = 0;
              this.onGround = true;
            } else if (this.oldY >= v13568.y + v13568.height) {
              this.y = v13568.y + v13568.height;
              this.yVel = 0;
              this.onGround = true;
            } else if (this.oldX - this.scale >= v13568.x + v13568.width - 0.00001) {
              this.x = v13568.x + v13568.width + this.scale;
              this.xVel = 0;
            } else if (this.oldX + this.scale <= v13568.x - v13568.width + 0.00001) {
              this.x = v13568.x - v13568.width - this.scale;
              this.xVel = 0;
            } else if (this.oldZ - this.scale >= v13568.z + v13568.length - 0.00001) {
              this.z = v13568.z + v13568.length + this.scale;
              this.zVel = 0;
            } else if (this.oldZ + this.scale <= v13568.z - v13568.length + 0.00001) {
              this.z = v13568.z - v13568.length - this.scale;
              this.zVel = 0;
            }
          }
        }
        for (var v13576 in game.map.manager.spawnables) {
          v13568 = game.map.manager.spawnables[v13576];
          if (v13568.active && v13568.ai && this.collidesAcc(v13568)) {
            game.pickupSpawnable(this, v13568);
          }
        }
        v13516 = null;
      }
      this.didMov = UTILS.getD3D(this.x, this.y, this.z, this.oldX, this.oldY, this.oldZ) >= 0.1 ? 1 : 0;
      if (this.invincibleOnStuck) {
        var v13579 = this.speed && !this.hitDelayC && !this.waitShoot && !this.breakMove && v13549;
        if (v13579 && this.target && this.target.isPlayer && this.target.id == this.oldTargetId && !this.didMov) {
          this.stuckTime += p16908;
        } else if (this.didMov) {
          this.stuckTime = 0;
          if (!this.permInvincible) {
            this.invincible = false;
          }
        }
        if (v13579 && this.target && this.target.isPlayer && this.target.id == this.oldTargetId && this.stuckTime >= vLN20003) {
          this.stuckCount++;
          this.stuckTime = 0;
          this.wasStuck = true;
          this.invincible = true;
          if (this.stuckCount == 4) {
            this.permInvincible = true;
            game.broadcast("so", "mystery_1", 2, 1);
          }
        }
      } else if (this.ignoreOnStuck) {
        var v13579 = this.speed && !this.hitDelayC && !this.waitShoot && !this.breakMove && v13549;
        if (v13579 && this.target && this.target.isPlayer && this.target.id == this.oldTargetId && !this.didMov) {
          this.stuckTime += p16908;
        } else if (this.didMov) {
          this.stuckTime = 0;
        }
        if (v13579 && this.target && this.target.isPlayer && this.target.id == this.oldTargetId && this.stuckTime >= vLN20003) {
          this.stuckTime = 0;
          this.target = null;
          this.actionFreq = 0;
          this.ignoreList[this.oldTargetId] = vLN20002;
          this.wasStuck = true;
        }
      } else if (this.driftOnStuck) {
        if (!this.forceDirectionTimer) {
          var v13579 = this.speed && !this.hitDelayC && !this.waitShoot && !this.breakMove && v13549;
          if (v13579 && this.target && this.target.isPlayer && this.target.id == this.oldTargetId && !this.didMov) {
            this.stuckTime += p16908;
          } else if (this.didMov) {
            this.stuckTime = 0;
          }
          if (v13579 && this.target && this.target.isPlayer && this.target.id == this.oldTargetId && this.stuckTime >= vLN20003) {
            this.stuckTime = 0;
            this.forceDirection = UTILS.getRandom([1, -1]);
            this.forceDirectionTimer = 2000;
            this.wasStuck = true;
          }
        } else if (this.forceDirectionTimer) {
          this.forceDirectionTimer -= p16908;
          if (this.forceDirectionTimer <= 0) {
            this.forceDirectionTimer = 0;
            this.forceDirection = null;
          } else {
            var v13580 = this.speed * vLN1171 * p16908 * 0.01;
            this.xVel = this.forceDirection * v13580 * Math.sin(this.xD - Math.PI / 4) * Math.cos(this.yD);
            this.zVel = this.forceDirection * v13580 * Math.cos(this.xD - Math.PI / 4) * Math.cos(this.yD);
          }
        }
      }
      if (this.lastHit.tim) {
        this.lastHit.tim -= p16908;
        if (this.lastHit.tim <= 0) {
          this.lastHit = {};
        }
      }
      if (this.y <= game.map.deathY) {
        this.kill(this.lastHit.doer);
      }
      for (var v13581 = this.posHist.length - 1; v13581 >= 0; --v13581) {
        if (game.now - this.posHist[v13581].t >= config.stateHistory) {
          this.posHist.splice(v13581, 1);
        }
      }
      this.posHist.unshift({
        t: game.now,
        x: this.x,
        y: this.y,
        z: this.z
      });
    }
  };
  this.fetchState = function (p16909) {
    var v13582 = game.now - p16909.ping - 200;
    for (var vLN02488 = 0; vLN02488 < this.posHist.length; ++vLN02488) {
      if (v13582 >= this.posHist[vLN02488].t) {
        return this.posHist[vLN02488];
      }
    }
  };
  this.giveEffect = function (p16910, p16911) {
    p16911 = p16911 || 1;
    var v13583 = game.effectConfig[p16910];
    if (v13583) {
      if (this.effects[p16910]) {
        this.effects[p16910] += p16911;
      } else {
        this.effects[p16910] = p16911;
      }
      if (this.effects[p16910] > v13583.max) {
        var v13584 = this.effects[p16910] - v13583.max;
        this.effects[p16910] = v13583.max;
        if (v13583.timer) {
          for (var vLN02490 = 0; vLN02490 < v13584; vLN02490++) {
            if (this.attributeTimers[p16910][vLN02490]) {
              this.attributeTimers[p16910][vLN02490] = v13583.timer * 1000;
            } else {
              this.attributeTimers[p16910].push(v13583.timer * 1000);
            }
          }
        }
        return;
      }
      if (v13583.timer) {
        for (var vLN02490 = 0; vLN02490 < p16911; vLN02490++) {
          this.attributeTimers[p16910].push(v13583.timer * 1000);
        }
      }
      v13583.execute(game, this);
    }
  };
  this.removeEffect = function (p16912, p16913) {
    var v13585 = true;
    var v13586 = game.effectConfig[p16912];
    if (p16913 && this.effects[p16912]) {
      this.effects[p16912]--;
      v13585 = !!(this.effects[p16912] <= 0);
    }
    if (v13585) {
      this.clearEffect(p16912);
    } else {
      v13586.execute(game, this);
    }
  };
  this.clearEffect = function (p16914) {
    var v13587 = game.effectConfig[p16914];
    if (this.effects[p16914]) {
      this.effects[p16914] = null;
    }
    this.attributes[v13587.key] = v13587.def;
    this.attributeTimers[v13587.index].length = 0;
    if (v13587.clear) {
      v13587.clear(this);
    }
  };
  this.forceTeam = function (p16915, p16916, p16917, p16918) {
    if (!p16917 || !(UTILS.randFloat(0, 100).round(2) > p16917)) {
      this._team = this.team;
      this.team = p16915;
      this.forceTeamTimer = p16916;
      this.target = null;
      this.actionFreq = 0;
      if (p16918) {
        game.challenges.update(game, "cvrt", 1, null, p16918);
      }
    }
  };
  this.changeHealth = function (p16919, p16920, p16921, p16922) {
    if (p16920 != this) {
      if (game.instaKillTimer && p16920 && p16920.isPlayer) {
        p16919 = this.health ? -(this.health * 2) : p16919;
      }
      if (this.health) {
        var v13588 = this.health;
        if (p16922) {
          this.health = p16919;
        } else {
          this.health += p16919;
        }
        if (this.health <= 0) {
          this.kill(p16920);
        } else if (p16919 > 0) {
          if (this.health > this.maxHealth) {
            this.health = this.maxHealth;
          }
        } else {
          if (p16920 && p16920.isPlayer && this.onAIDamage) {
            game.onTrigger(p16920, this);
          }
          if (p16920 && p16920.isPlayer && this.onAIHalfHealth && v13588 > this.maxHealth / 2 && this.health <= this.maxHealth / 2) {
            game.onTrigger(p16920, this);
          }
        }
      }
      if (p16920) {
        if (p16920.isPlayer && p16919 < 0) {
          if (!this.dmgList.includes(p16920.id)) {
            this.dmgList.push(p16920.id);
          }
          p16920.dmgDealt -= p16919;
          this.lastHit = {
            doer: p16920,
            tim: 8000
          };
        }
        if (p16919 < this.behaviour == 1 && (!p16920.team || p16920.team != this.team) && (p16921 || !this.target) && (p16920.isPlayer || this.targetAI) && (!p16920.isPlayer || this.targPlr)) {
          if (this.target != p16920) {
            this.emitSound(this.aggroSound);
          }
          if (!this.ignoreList[p16920.id]) {
            this.target = p16920;
            this.actionFreq = 5000;
          }
        }
      }
    }
  };
  this.kill = function (p16923, p16924) {
    if (this.active) {
      this.active = false;
      this.health = 0;
      this.pathIndex = 0;
      this.pathIndDir = 1;
      if (!p16924) {
        if (p16923 && p16923.isPlayer) {
          p16923.aiKills++;
        }
        this.emitSound(this.deathSound);
        this.rspTimer = this.respawnR ? UTILS.randInt(100, this.respawnT || 5000) : this.respawnT || 0;
        if (this.onAIDeath) {
          game.onTrigger(p16923, this);
        }
        if (game.mode.onAIDeath) {
          game.mode.onAIDeath(game, this, p16923);
        }
        if (this.reward && game.isPubType()) {
          var v13589 = game.map.manager.pathNodes[this.rewardNode];
          for (var vLN02491 = 0; vLN02491 < game.players.list.length; ++vLN02491) {
            if (!game.players.list[vLN02491].isBot && (this.rewardReq != 0 || game.players.list[vLN02491].active) && (this.rewardReq != 1 || game.players.list[vLN02491].active && this.dmgList.includes(game.players.list[vLN02491].id)) && (this.rewardReq != 2 || game.players.list[vLN02491].active && this.lastHit && this.lastHit.doer && this.lastHit.doer == game.players.list[vLN02491])) {
              var v13590 = game.getItemByChance(this.reward);
              if (v13590 && v13590 != -1) {
                if (this.rewardMethod === 1) {
                  game.dropSkin(game.players.list[vLN02491], v13590, undefined, this.x, this.y, this.z);
                }
                if (this.rewardMethod === 2 && v13589) {
                  game.dropSkin(game.players.list[vLN02491], v13590, undefined, v13589.x, v13589.y, v13589.z);
                } else {
                  game.giveSkin(game.players.list[vLN02491], v13590);
                }
              }
            }
          }
        }
        if (p16923 && p16923.attributes && p16923.attributes.siphon) {
          game.players.changeHealth(p16923, null, -p16923.attributes.siphon);
        }
      }
      if (!this.rspTimer) {
        p16893.removeFully(this);
      }
    }
  };
  this.collidesAcc = function (p16925) {
    return Math.min(this.x, this.oldX) - this.scale < p16925.x + p16925.width && Math.max(this.x, this.oldX) + this.scale > p16925.x - p16925.width && Math.min(this.z, this.oldZ) - this.scale < p16925.z + p16925.length && Math.max(this.z, this.oldZ) + this.scale > p16925.z - p16925.length && Math.min(this.y, this.oldY) <= p16925.y + p16925.height && Math.max(this.y, this.oldY) + this.height * 2 >= p16925.y - p16925.height;
  };
}
module.exports = function (game, p16927, p16928) {
  this.ais = [];
  this.forceTargetTimer = 0;
  this.forceTarget = null;
  this.forceDanceTimer = 0;
  this.forceDance = null;
  var v13591;
  var v13592;
  var v13593;
  var vA770 = [];
  var vThis138 = this;
  var vLN800 = 800;
  this.cSpawn = function (p16929) {
    vThis138.spawn(p16929[0], p16929[1], p16929[2], p16929[3], p16929[4], p16929[5], p16929[6], true);
  };
  this.spawn = function (p16930, p16931, p16932, p16933, p16934, p16935, p16936, p16937) {
    if (p16937 || !(this.ais.length >= config.aiLimit)) {
      var v13594 = new f2119(game, vThis138, p16927);
      if (!p16930) {
        p16930 = UTILS.generateSID(this.ais);
      }
      v13594.init(p16933, p16934, p16935, p16932, p16931, p16936, p16930);
      this.ais.push(v13594);
      return v13594;
    }
  };
  this.update = function (p16938) {
    if (this.forceTargetTimer) {
      this.forceTargetTimer -= p16938;
      if (this.forceTargetTimer <= 0) {
        this.forceTargetTimer = 0;
        this.forceTarget = null;
      }
    }
    if (this.forceDanceTimer) {
      this.forceDanceTimer -= p16938;
      if (this.forceDanceTimer <= 0) {
        this.forceDanceTimer = 0;
        this.forceDance = false;
      }
    }
    for (var v13595 = this.ais.length - 1; v13595 >= 0; --v13595) {
      if (this.ais[v13595]) {
        this.ais[v13595].update(p16938);
      }
    }
  };
  this.servAnim = function (p16939, p16940, p16941) {
    v13591 = vThis138.findBySid(p16939);
    if (v13591) {
      vThis138.playAnim(v13591, p16941 ? p16940 : config.clipNames[p16940], 1);
    }
  };
  this.playAnim = function (p16942, p16943, p16944, p16945) {
    if (p16942.hasAnim && p16943) {
      if (p16928) {
        var v13596 = config.clipNames.indexOf(p16943);
        if (p16945 || v13596 >= 0) {
          for (var vLN02492 = 0; vLN02492 < game.players.list.length; ++vLN02492) {
            v13592 = game.players.list[vLN02492];
            if ((v13592.active || v13592.spectating) && (v13592.spectating || !(UTILS.getD3D(v13592.x, v13592.y, v13592.z, p16942.x, p16942.y, p16942.z) > vLN800))) {
              v13592.send("ana", p16942.sid, p16945 ? p16943 : v13596, p16945 ? 1 : 0);
            }
          }
        }
      } else if (p16942.meshRef && p16942.meshRef.playClip) {
        p16942.meshRef.playClip(p16943, p16944);
      }
    }
  };
  this.hideAll = function () {
    for (var vLN02493 = 0; vLN02493 < this.ais.length; ++vLN02493) {
      if (this.ais[vLN02493].mesh) {
        this.ais[vLN02493].mesh.visible = false;
      }
      this.ais[vLN02493].forcePos = !this.ais[vLN02493].latestData;
      this.ais[vLN02493].latestData = false;
    }
  };
  this.resetHidden = function () {
    for (var vLN02494 = 0; vLN02494 < this.ais.length; ++vLN02494) {
      if (this.ais[vLN02494].mesh && !this.ais[vLN02494].mesh.visible && this.ais[vLN02494].meshRef && this.ais[vLN02494].meshRef.stopAllClips) {
        this.ais[vLN02494].meshRef.stopAllClips();
      }
    }
  };
  this.findBySid = function (p16946) {
    for (var vLN02495 = 0; vLN02495 < this.ais.length; ++vLN02495) {
      if (this.ais[vLN02495].sid == p16946) {
        return this.ais[vLN02495];
      }
    }
    return null;
  };
  this.syncAll = function (p16947) {
    vThis138.hideAll();
    if (p16947) {
      for (var vLN02496 = 0; vLN02496 < p16947.length;) {
        v13591 = vThis138.findBySid(p16947[vLN02496]);
        if (v13591) {
          if (v13591.mesh) {
            v13591.mesh.visible = true;
          }
          v13591.latestData = true;
          v13591.x = p16947[vLN02496 + 1] || 0;
          v13591.y = (p16947[vLN02496 + 2] || 0) + Math.sin(v13591.bobVal) * v13591.bobD;
          v13591.z = p16947[vLN02496 + 3] || 0;
          v13591.xD = p16947[vLN02496 + 4] || 0;
          v13591.yD = p16947[vLN02496 + 5] || 0;
          if (!v13591.forcePos && v13591.mesh) {
            v13591.dt = 0;
            v13591.x1 = v13591.mesh.position.x;
            v13591.y1 = v13591.mesh.position.y;
            v13591.z1 = v13591.mesh.position.z;
            v13591.xDir1 = v13591.mesh.rotation.y;
            v13591.interpolate = true;
          } else {
            v13591.interpolate = false;
            if (v13591.mesh) {
              v13591.mesh.position.x = v13591.x;
              v13591.mesh.position.y = v13591.y;
              v13591.mesh.position.z = v13591.z;
            }
          }
          v13591.forcePos = false;
          v13591.health = p16947[vLN02496 + 6] || 0;
          v13591.didMov = p16947[vLN02496 + 7] || 0;
          v13591.team = p16947[vLN02496 + 8] || 0;
        }
        vLN02496 += 9;
      }
      vThis138.resetHidden();
    }
  };
  this.sync = function () {
    if (this.ais.length) {
      for (var vLN02497 = 0; vLN02497 < game.players.list.length; ++vLN02497) {
        v13592 = game.players.list[vLN02497];
        if (v13592.active || v13592.spectating) {
          vA770.length = 0;
          for (var vLN02498 = 0; vLN02498 < this.ais.length; ++vLN02498) {
            v13593 = this.ais[vLN02498];
            if (v13593.active && (v13592.spectating || !(UTILS.getD3D(v13592.x, v13592.y, v13592.z, v13593.x, v13593.y, v13593.z) > vLN800))) {
              if (v13593.sentTo.indexOf(v13592.id) >= 0) {
                vA770.push(v13593.sid, v13593.x.round(1), v13593.y.round(1), v13593.z.round(1), v13593.xD.round(2), v13593.yD.round(2), Math.floor(v13593.health), v13593.didMov, v13593.team);
              } else {
                v13593.sentTo.push(v13592.id);
                v13592.send("aai", v13593.getData());
              }
            }
          }
          v13592.send("ai", vA770.length ? vA770 : 0);
        }
      }
    }
  };
  this.removeFully = function (p16948) {
    if (p16948) {
      var v13597 = this.ais.indexOf(p16948);
      if (v13597 >= 0) {
        for (var vLN02499 = 0; vLN02499 < this.ais[v13597].sentTo.length; ++vLN02499) {
          p16928.send(this.ais[v13597].sentTo[vLN02499], "rai", p16948.sid);
        }
        this.ais.splice(v13597, 1);
      }
    }
  };
  this.removeBySid = function (p16949) {
    for (var v13598 = vThis138.ais.length - 1; v13598 >= 0; --v13598) {
      if (vThis138.ais[v13598].sid == p16949) {
        vThis138.remove(vThis138.ais[v13598]);
        vThis138.ais.splice(v13598, 1);
      }
    }
  };
  this.remove = function (p16950) {
    if (p16927 && p16950.mesh) {
      p16927.scene.remove(p16950.mesh);
      p16950.mesh = null;
    }
    p16950.active = false;
  };
  this.reset = function () {
    this.forceTarget = null;
    this.forceTargetTimer = 0;
    this.forceDance = false;
    this.forceTDanceTimer = 0;
    for (var vLN02500 = 0; vLN02500 < this.ais.length; ++vLN02500) {
      this.remove(this.ais[vLN02500]);
    }
    this.ais.length = 0;
  };
};